
import { useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../jsx/axiosClient";

export function FileuploadLogic(userSession, activeSection) {
  const MySwal = withReactContent(Swal);
  // Media states
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(false);
const [isGenerating, setIsGenerating] = useState(false);
  // Common fields
  const [mediaTitle, setMediaTitle] = useState("");
  const [mediaTitleError, setMediaTitleError] = useState(false);
  const [mediaDescription, setMediaDescription] = useState("");
  const [mediaDescriptionError, setMediaDescriptionError] = useState(false);
  const [mediaNarrator, setMediaNarrator] = useState("m5");
  const [mediaLanguage, setMediaLanguage] = useState("en-US");
  const [mediaDescriptionType, setMediaDescriptionType] = useState("Brief");
  const [mediaVoice, setMediaVoice] = useState("Male");
  const [mediaFormats, setMediaFormats] = useState(["video"]);
  const [mediaFormatError, setMediaFormatError] = useState(false);
  // YouTube
  const [youtubeUrl, setYoutubeUrl] = useState("");
    const [ytTitle, setYtTitle] = useState("");
      const [ytTitleError, setYtTitleError] = useState(false);
  const [ytDescription, setYtDescription] = useState("");
    const [ytDescriptionError, setYtDescriptionError] = useState(false);
  const [ytFormats, setYtFormats] = useState(["video"]);
    const [ytFormatError, setYtFormatError] = useState(false);
  const [ytNarrator, setYtNarrator] = useState("m5");
  const [ytLanguage, setYtLanguage] = useState("en-US");
  const [ytDescType, setYtDescType] = useState("Brief");
  const [ytVoice, setYtVoice] = useState("Male");
  const [youtubeUrlError, setYoutubeUrlError] = useState(false);
  // Drag/drop
  const [dragging, setDragging] = useState(false);

  // Format options
  // const formats = [
  //   { label: "Text (Transcript)", value: "text" },
  //   { label: "Audio", value: "audio" },
  //   { label: "Video (with embedded audio)", value: "video" },
  // ];
const formats = [
  { labelHtml: "Text <br />(transcript)", value: "text" },
  { labelHtml: "Audio", value: "audio" },
  { labelHtml: "Video (with <br /> Audio Description)", value: "video" },
];

  // Toggle format
  const toggleFormat = (value) => {
    if (value === "video") return;
    setMediaFormats((prev) => {
      let updated;
      if (prev.includes(value)) {
        updated = prev.filter((f) => f !== value);
      } else {
        updated = [...prev, value];
      }
      if (!updated.includes("video")) updated.push("video");
      setMediaFormatError(updated.length === 0);
      return updated;
    });
  };
const toggleYtFormat = (value) => {
    if (value === "video") return;
    setYtFormats((prev) => {
      let updated;
      if (prev.includes(value)) {
        updated = prev.filter((f) => f !== value);
      } else {
        updated = [...prev, value];
      }
      if (!updated.includes("video")) updated.push("video");
      setYtFormatError(updated.length === 0);
      return updated;
    });
  };
  // File handling
  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
      setFileError(false);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
      setFileError(false);
    }
  };

const handleSubmit = async (e, formValues) => {
    console.log("handleSubmit fn")
     e.preventDefault();
    const formData = new FormData();
  formData.append("file", file);
  formData.append("title", formValues.mediaTitle || "Video Description");
  formData.append("description", formValues.mediaTitle || "Video Description");
  formData.append("narrator", formValues.mediaNarrator);
  formData.append("language", formValues.mediaLanguage);
  formData.append("description_type", formValues.mediaDescriptionType);
  formData.append("voice", formValues.mediaVoice);
    formData.append("formats", JSON.stringify(formValues.mediaFormats));
     console.log("FormData contents:");
        for (let [key, val] of formData.entries()) {
          console.log(key, val);
     }
    try {
//if (isMedia) {
  const confirm = await MySwal.fire({
    icon: "warning",
    title: "Confirm Upload",
    html: `
      By uploading, you confirm that you own this video or have the legal right to share it.<br/>
      Please make sure your content doesn't violate copyright laws.<br/><br/>
      <b>You are responsible for the videos you post.</b>
    `,
    showCancelButton: true,
    confirmButtonText: "Yes, Upload",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) {
    setIsGenerating(false);
    return; 
  }
      MySwal.fire({
        title: "Uploading...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => MySwal.showLoading(),
      });
      const response = await api.post("/convert-user-file", formData, {
        headers: {
          Authorization: `Bearer ${userSession.access_token}`,
        },
        withCredentials: true,
      });
      const result = response.data;
      MySwal.close();
      if (result.status === "success") {
        await MySwal.fire({
          icon: "success",
          title: "Upload Successful",
          text:
            result.message ,         
          confirmButtonText: "OK",
        });
        window.location.reload();
      } else {
        MySwal.fire({
          icon: "error",
          title: "Upload Failed",
          text:
            result.message || "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      MySwal.fire({
        icon: "error",
        title: "Server Error",
        text:
          error.response?.data?.message ||
          "Could not connect to backend. Please try again later.",
      });
    }
  };

 
 //const handleYoutubeSubmit = async () => {
  const handleYoutubeSubmit = async (e, formValues) => {
    console.log("handleYoutubeSubmit fn")
     e.preventDefault();
   // setIsGenerating(true);
   // let valid = true;
    const formData = new FormData();
          formData.append("youtube_url", youtubeUrl);
     formData.append("title", formValues.youtubeTitle || "Video Description");
    formData.append("description", formValues.youtubeTitle || "Video Description");
    formData.append("narrator", formValues.youtubeNarrator);
    formData.append("language", formValues.youtubeLanguage);
    formData.append("description_type", formValues.youtubeDescriptionType);
    formData.append("voice", formValues.youtubeVoice);
    formData.append("formats", JSON.stringify(formValues.youtubeFormats));
        console.log("FormData contents:");
        for (let [key, val] of formData.entries()) {
            console.log(key, val);
        }
    try {
  const confirm = await MySwal.fire({
    icon: "warning",
    title: "Confirm Upload",
    html: `
      By uploading, you confirm that you own this video or have the legal right to share it.<br/>
      Please make sure your content doesn't violate copyright laws.<br/><br/>
      <b>You are responsible for the videos you post.</b>
    `,
    showCancelButton: true,
    confirmButtonText: "Yes, Upload",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) {
    setIsGenerating(false);
    return; 
  }
      MySwal.fire({
        title: "Uploading...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => MySwal.showLoading(),
      });

      const response = await api.post("/convert-user-file", formData, {
        headers: {
          Authorization: `Bearer ${userSession.access_token}`,
        },
        withCredentials: true,
      });

      const result = response.data;
      MySwal.close();

      if (result.status === "success") {
        await MySwal.fire({
          icon: "success",
          title: "Upload Successful",
          text:
            result.message ,
          confirmButtonText: "OK",
        });
        window.location.reload();
      } else {
        MySwal.fire({
          icon: "error",
          title: "Upload Failed",
          text:
            result.message || "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      MySwal.fire({
        icon: "error",
        title: "Server Error",
        text:
          error.response?.data?.message ||
          "Could not connect to backend. Please try again later.",
      });
    }
  };

 const handleSubmit1 = async () => {
    console.log("handleSubmit fn")
    setFileError(false);
setYoutubeUrlError(false);
setMediaTitleError(false);
setMediaFormatError(false);

    setIsGenerating(true);

    let valid = true;
    const formData = new FormData();

    
const isYouTube = activeSection === "youtube";
const isMedia = activeSection === "media";


    if (!isYouTube && !isMedia) {
      console.log("!isYouTube && !isMedia")
   
    setFileError(true);
    setYoutubeUrlError(true);
    valid = false;
     return;
    }

    if (isMedia) {
        formData.delete("youtube_url");

      if (!file) {
        setFileError(true);
        valid = false;
      }
      if (!mediaTitle.trim()) {
        setMediaTitleError(true);
        valid = false;
      }
      if (mediaFormats.length === 0) {
        setMediaFormatError(true);
        valid = false;
      }
      if (!valid) return;

      formData.append("file", file);
      
    }


    if (isYouTube) {
        formData.delete("file");

      if (!youtubeUrl.trim()) {
        setYoutubeUrlError(true);
        valid = false;
      }
      if (!mediaTitle.trim()) {
        setMediaTitleError(true);
        valid = false;
      }
      if (mediaFormats.length === 0) {
        setMediaFormatError(true);
        valid = false;
      }
      if (!valid) return;

      formData.append("youtube_url", youtubeUrl);
    }

    formData.append("title", mediaTitle);
    formData.append("description", mediaDescription);
    formData.append("narrator", mediaNarrator);
    formData.append("language", mediaLanguage);
    formData.append("description_type", mediaDescriptionType);
    formData.append("voice", mediaVoice);
    formData.append("formats", JSON.stringify(mediaFormats));

        console.log("FormData contents:");
        for (let [key, val] of formData.entries()) {
            console.log(key, val);
        }
    try {

//if (isMedia) {
  const confirm = await MySwal.fire({
    icon: "warning",
    title: "Confirm Upload",
    html: `
      By uploading, you confirm that you own this video or have the legal right to share it.<br/>
      Please make sure your content doesn't violate copyright laws.<br/><br/>
      <b>You are responsible for the videos you post.</b>
    `,
    showCancelButton: true,
    confirmButtonText: "Yes, Upload",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) {
    setIsGenerating(false);
    return; 
  }



      MySwal.fire({
        title: "Uploading...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => MySwal.showLoading(),
      });

      const response = await api.post("/convert-user-file", formData, {
        headers: {
          Authorization: `Bearer ${userSession.access_token}`,
        },
        withCredentials: true,
      });

      const result = response.data;
      MySwal.close();

      if (result.status === "success") {
        await MySwal.fire({
          icon: "success",
          title: "Upload Successful",
          text:
            result.message ||
            (isYouTube
              ? "YouTube video processed successfully!"
              : "Media uploaded successfully!"),
          confirmButtonText: "OK",
        });
        window.location.reload();
      } else {
        MySwal.fire({
          icon: "error",
          title: "Upload Failed",
          text:
            result.message || "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      MySwal.fire({
        icon: "error",
        title: "Server Error",
        text:
          error.response?.data?.message ||
          "Could not connect to backend. Please try again later.",
      });
    }
  };




  return {
    // state vars
    file,
    fileError,
    mediaTitle,
    mediaTitleError,
    mediaDescription,
    mediaDescriptionError,
    mediaNarrator,
    mediaLanguage,
    mediaDescriptionType,
    mediaVoice,
    mediaFormats,
    mediaFormatError,
    youtubeUrl,
    youtubeUrlError,
    dragging,
    formats,

    // setters
    setFile,
    setFileError,
    setMediaTitle,
    setMediaDescription,
    setMediaNarrator,
    setMediaLanguage,
    setMediaDescriptionType,
    setMediaVoice,
    setMediaFormats,
    setMediaFormatError,
    setMediaTitleError,
    setMediaDescriptionError,

    //youtube
    setYoutubeUrl,
    setYoutubeUrlError,
    setDragging,
    ytTitle,
    ytDescription,
ytFormats,
ytNarrator,
ytLanguage,
ytDescType,
ytVoice,
setYtTitleError,
setYtTitle,
ytTitleError,
setYtDescription,
setYtNarrator,
setYtLanguage,
setYtDescType,
setYtVoice,
setYtDescriptionError,
ytDescriptionError,
    // handlers
    toggleFormat,
    handleDrop,
    handleFileChange,
    handleSubmit,
    toggleYtFormat,
    handleYoutubeSubmit,
  };
}
